export enum NavigationItemType {
  DEFAULT = 'default',
  IMAGE_GRID = 'imageGrid',
  FEATURED = 'featured',
  BRAND_LOGOS = 'brandLogos',
  WALL = 'wall',
  EXTRAS = 'extras',
}
